const InvoicedSiigo = {
  Unbill: "UNBILL",
  SiigoAccepted: "SIIGO_ACCEPTED",
  SiigoError: "SIIGO_ERROR",
  DianAccepted: "DIAN_ACCEPTED",
  DianError: "DIAN_ERROR",
  PendingUnbill: "PENDING_UNBILL",
  Error: "ERROR",
  Sent: "SENT",
  Created: "CREATED"
};

export default Object.freeze(InvoicedSiigo);
